var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"portal-box"},[_c('img',{staticClass:"img-box",attrs:{"src":require("../assets/a.svg"),"alt":"description"}}),_c('div',{staticClass:"content-wrap"},[_c('div',{staticClass:"txt-portal"},[(_vm.loading)?_c('span',{staticClass:"spinner"}):_vm._e(),_vm._v(" "+_vm._s(_vm.message)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }